import { US_STATES } from '@bonsai/shared';

// Re-exported so the steps module keeps importing every field atom from one
// place; the component itself lives alone to satisfy react/no-multi-comp.
export { SuggestTag } from './SuggestTag';

/** Region choice that leaves the region to be assigned from the venue's state. */
export const ASSIGN_FROM_STATE = 'Assign from state';

export const MONO = "'JetBrains Mono', ui-monospace, monospace";
/** States offered in the venue address form. Single-sourced in @bonsai/shared
 *  so the backend's StateCode validation and this list cannot drift (BON-586). */
export const STATES = US_STATES;

export { fieldStyle } from '../primitives/field-style';

export { Field } from '../primitives/Field';

export const hintText = (text: string) => (
  <span style={{ fontSize: 9.5, color: 'var(--nb-subtle)' }}>{text}</span>
);
